import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Palette, Image as ImageIcon, Type, LayoutTemplate } from 'lucide-react';
export function AdminBrandingPage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-773">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-774">
        <div className="flex items-center gap-4" data-id="element-775">
          <span className="text-xl font-bold text-red-500" data-id="element-776">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-777"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-778">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-779">
              Dashboard
            </Link>
            <Link to="/admin/branding" className="text-textMain" data-id="element-780">
              Branding
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-781">
        <div className="mb-8" data-id="element-782">
          <h1 className="text-2xl font-bold mb-1" data-id="element-783">Global Branding</h1>
          <p className="text-sm text-textMuted" data-id="element-784">
            Control system-wide themes, logos, and document styling defaults.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-785">
          <div className="space-y-8" data-id="element-786">
            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-787">
              <h3 className="font-semibold mb-6 flex items-center gap-2" data-id="element-788">
                <Palette className="w-5 h-5 text-primary" data-id="element-789" /> Color Tokens
              </h3>
              <div className="space-y-4" data-id="element-790">
                <div data-id="element-791">
                  <label className="block text-sm font-medium mb-2" data-id="element-792">
                    Primary Brand Color
                  </label>
                  <div className="flex items-center gap-4" data-id="element-793">
                    <div className="w-10 h-10 rounded bg-primary border border-border" data-id="element-794"></div>
                    <input type="text" defaultValue="#F59E0B" className="px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary font-mono" data-id="element-795" />
                  </div>
                </div>
                <div data-id="element-796">
                  <label className="block text-sm font-medium mb-2" data-id="element-797">
                    Background (Dark Mode)
                  </label>
                  <div className="flex items-center gap-4" data-id="element-798">
                    <div className="w-10 h-10 rounded bg-background border border-border" data-id="element-799"></div>
                    <input type="text" defaultValue="#0A0A0F" className="px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary font-mono" data-id="element-800" />
                  </div>
                </div>
                <div data-id="element-801">
                  <label className="block text-sm font-medium mb-2" data-id="element-802">
                    Surface (Dark Mode)
                  </label>
                  <div className="flex items-center gap-4" data-id="element-803">
                    <div className="w-10 h-10 rounded bg-surface border border-border" data-id="element-804"></div>
                    <input type="text" defaultValue="#14141A" className="px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary font-mono" data-id="element-805" />
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-806">
              <h3 className="font-semibold mb-6 flex items-center gap-2" data-id="element-807">
                <ImageIcon className="w-5 h-5 text-primary" data-id="element-808" /> Logos & Assets
              </h3>
              <div className="space-y-6" data-id="element-809">
                <div data-id="element-810">
                  <label className="block text-sm font-medium mb-2" data-id="element-811">
                    Application Logo
                  </label>
                  <div className="p-4 border-2 border-dashed border-border rounded-lg text-center hover:border-primary transition-colors cursor-pointer" data-id="element-812">
                    <span className="text-xl font-bold text-textMain" data-id="element-813">
                      Booker
                    </span>
                    <p className="text-xs text-textMuted mt-2" data-id="element-814">
                      Click to upload SVG or PNG
                    </p>
                  </div>
                </div>
                <div data-id="element-815">
                  <label className="block text-sm font-medium mb-2" data-id="element-816">
                    Favicon
                  </label>
                  <div className="p-4 border-2 border-dashed border-border rounded-lg text-center hover:border-primary transition-colors cursor-pointer" data-id="element-817">
                    <div className="w-8 h-8 rounded-full bg-primary mx-auto mb-2" data-id="element-818"></div>
                    <p className="text-xs text-textMuted" data-id="element-819">
                      Click to upload .ico or .png
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-8" data-id="element-820">
            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-821">
              <h3 className="font-semibold mb-6 flex items-center gap-2" data-id="element-822">
                <Type className="w-5 h-5 text-primary" data-id="element-823" /> Typography
              </h3>
              <div className="space-y-4" data-id="element-824">
                <div data-id="element-825">
                  <label className="block text-sm font-medium mb-2" data-id="element-826">
                    Primary Font Family
                  </label>
                  <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-827">
                    <option data-id="element-828">Inter, system-ui, sans-serif</option>
                    <option data-id="element-829">Roboto, system-ui, sans-serif</option>
                    <option data-id="element-830">SF Pro Display, system-ui</option>
                  </select>
                </div>
                <div data-id="element-831">
                  <label className="block text-sm font-medium mb-2" data-id="element-832">
                    Document Serif Font
                  </label>
                  <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-833">
                    <option data-id="element-834">Georgia, Cambria, serif</option>
                    <option data-id="element-835">Merriweather, serif</option>
                    <option data-id="element-836">Playfair Display, serif</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-837">
              <h3 className="font-semibold mb-6 flex items-center gap-2" data-id="element-838">
                <LayoutTemplate className="w-5 h-5 text-primary" data-id="element-839" /> Document
                Defaults
              </h3>
              <div className="space-y-4" data-id="element-840">
                <div data-id="element-841">
                  <label className="block text-sm font-medium mb-2" data-id="element-842">
                    Default Contract Footer
                  </label>
                  <textarea rows={3} defaultValue="Generated securely via Booker. Document ID: {{DocID}}" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-843"></textarea>
                </div>
                <div className="pt-4" data-id="element-844">
                  <button className="w-full py-2 bg-primary text-background rounded-lg text-sm font-medium hover:bg-primaryHover transition-colors" data-id="element-845">
                    Save Branding Settings
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}